import { apiClient } from "@base/api/client";
import type { MembershipPlan } from "@features/membership/model/types";

/**
 * GET /82office/membership/api/membership
 * 멤버십 조회
 *
 * Subscription이 없는 회사는 200 + {} 로 응답하므로 null로 정규화한다.
 * Error: NOT_BUILDBLOCK_USER - Only Buildblock accounts can access this endpoint.
 */
export async function fetchMembership(): Promise<Nullable<MembershipPlan>> {
  const { data } = await apiClient.get<MembershipPlan | { plan_description?: undefined }>(
    "/82office/membership/api/membership",
  );
  return data.plan_description !== undefined ? data : null;
}

/*
 * TanStack Query 사용 예시:
 *
 * import { useQuery } from "@tanstack/react-query";
 * import { fetchMembership } from "@features/membership/api/membership";
 *
 * const { data, isLoading, error } = useQuery({
 *   queryKey: ["membership"],
 *   queryFn: fetchMembership,
 * });
 */
